import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-single-car-slider"
}
const _hoisted_2 = { class: "c-single-car-slider__item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "c-single-car-color-selector" }
const _hoisted_5 = { class: "c-single-car-color-selector__exterior" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "c-single-car-color-selector__selected" }
const _hoisted_8 = {
  key: 0,
  class: "c-single-car-color-selector__interior"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "c-single-car-color-selector__selected" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($data.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: $options.currentColor.image.url,
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_3)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "c-single-car-color-selector__info" }, "Couleur extérieure", -1 /* HOISTED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.currentTrim.colors, (color, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{'-is-active': $data.code == color.code}, "c-single-car-color-selector__item"]),
                style: _normalizeStyle($options.getColorStyle(color)),
                onClick: $event => ($data.code = color.code)
              }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("p", _hoisted_7, _toDisplayString($options.colorName), 1 /* TEXT */)
          ]),
          ($data.currentTrim.inside_colors && $data.currentTrim.inside_colors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "c-single-car-color-selector__info" }, "Intérieur", -1 /* HOISTED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.currentTrim.inside_colors, (color, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass([{'-is-active': $data.icode == color.code,'-is-last': index == $data.currentTrim.inside_colors.length-1}, "c-single-car-color-selector__item"]),
                    style: _normalizeStyle({backgroundColor: color.color}),
                    onClick: $event => ($data.icode = color.code)
                  }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("p", _hoisted_10, _toDisplayString($options.icolorName), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}